import React, { useState, useEffect } from "react";

import "react-toastify/dist/ReactToastify.css";

import { Link, useLocation, useParams } from "react-router-dom";

const Sidebar = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const isStudentProfile = pathname === `/${id}/profile/students`;
  const isTeacherProfile = pathname === `/${id}/profile/teachers`;
  const profilesOpen = isStudentProfile || isTeacherProfile;
  const hash = window.location.hash.slice(1);

  return (
    <>
      <div class="docs-nav-sidebar border-0">
        <div class="py-5"></div>
        <div class=" docs-nav" data-simplebar>
          <nav class="navigation navbar navbar-expand-lg">
            <div class="collapse navbar-collapse mb-0" id="navbarNav">
              <ul class="navbar-nav flex-column text-start" id="sidebarnav">
                <li class="navbar-header mt-3 mb-0"></li>

                <li class="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/dashboard"}
                    class={hash === "/" + id + "/dashboard" ? "nav-link" : "nav-link"}
                  >
                    <i className="bi bi-house-fill text-success fs-n"></i>
                    <span className="fs-n ms-2">Dashboard</span>
                  </Link>
                </li>

                <li class="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/control"}
                    class={hash === "/" + id + "/control" ? "nav-link active" : "nav-link"}
                  >
                    <i className="bi bi-building text-warning fs-n"></i>
                    <span className="fs-n ms-2">Control Centre</span>
                  </Link>
                </li>

                <li class="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/cbt"}
                    class={hash === "/" + id + "/cbt" ? "nav-link active" : "nav-link"}
                  >
                    <i class="bi bi-pc-display-horizontal text-info fs-n"></i>
                    <span className="fs-n ms-2">
                      CBT Workspace {" "}
                     <span class="badge rounded-pill bg-purple text-small fs-6">Pro</span>
                    </span>
                  </Link>
                </li>

                <li class="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/exercise"}
                    class={hash === "/" + id + "/exercise" ? "nav-link active" : "nav-link"}
                  >
                    <i class="bi bi-list-stars text-success fs-n"></i>
                    <span className="fs-n ms-2">
                      Exercise {" "}
                     <span class="badge rounded-pill bg-purple text-small fs-6">Pro</span>
                    </span>
                  </Link>
                </li>

                <li class="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/account"}
                    class={hash === "/" + id + "/account" ? "nav-link active" : "nav-link"}
                  >
                    <i className="bi bi-bank text-warning fs-n"></i>
                    <span className="fs-n ms-2">Account Centre {" "}
                    <span class="badge rounded-pill bg-purple text-small fs-6">Pro</span>
                    </span>
                  </Link>
                </li>


                <li className="nav-item cursor-pointer ">
                  <a
                    className={profilesOpen ? "nav-link active" : "nav-link"}
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#navProfile"
                    aria-expanded={profilesOpen}
                    aria-controls="navProfile"
                  >
                    <i className="nav-icon fe fe-user text-pink fs-n"></i>
                    <span className="fs-n ms-2">Users</span>
                  </a>
                  <div
                    id="navProfile"
                    className={profilesOpen ? "collapse show" : "collapse"}
                    data-bs-parent="#sideNavbar"
                  >
                    <ul className="nav flex-column">
                      <li className="nav-item">
                        <Link
                          to={"../" + id + "/profile/teachers"}
                          class={
                            isTeacherProfile
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i class="bi bi-person-lines-fill fs-4"></i>
                          <span className="fs-n fw-light ms-2">Teachers</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to={"../" + id + "/profile/students"}
                          class={
                            isStudentProfile
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i class="bi bi-person-lines-fill fs-4"></i>
                          <span className="fs-n fw-light ms-2">Students</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li className="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/results"}
                    class={hash === "/" + id + "/results" ? "nav-link active" : "nav-link"}
                  >
                    <i className="bi bi-person-check text-light-primary fs-n"></i>
                    <span className="fs-n ms-2">Results</span>
                  </Link>
                </li>

                <li className="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/services"}
                    class={
                      hash === "/" + id + "/services" ? "nav-link active" : "nav-link"
                    }
                  >
                    <i className="bi bi-speedometer2 text-danger fs-n"></i>
                    <span className="fs-n ms-2">App Status</span>
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div class="nav-footer border-0 py-0">
        <nav class="navigation navbar navbar-expand-lg">
            <div class="collapse navbar-collapse mb-0" id="navbarNav">
              <ul class="navbar-nav flex-column text-start" id="sidebarnav">
                <li class="nav-item cursor-pointer ">
                  <Link
                    to={"../" + id + "/logout"}
                    class={hash === "/logout" ? "nav-link active2" : "nav-link"}
                  >
                    <i className="bi bi-power text-danger fs-n"></i>
                    <span className="fs-n ms-2">Log-Out</span>
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
